import React, { Fragment } from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { WizardMode } from '../../wizard-constants.js';
import { getStepProperties } from '../../wizard-utils.js';
import { WizardHorizontalHeaderStep } from '../wizard-horizontal-header-step/wizard-horizontal-header-step.js';
import './wizard-horizontal-header.css';
const WIZARD_HORIZONTAL_HEADER_MAX_SHOWING_STEPS = 6;
function getClosestValuesFromIndex(array, index, totalWanted) {
    const totalHalf = Math.trunc(totalWanted / 2);
    const totalOffset = totalWanted % 2 === 0 ? 1 : 0;
    if (index <= totalHalf - totalOffset) {
        return array.slice(0, totalWanted);
    }
    if (index >= array.length - totalHalf - totalOffset) {
        return array.slice(array.length - totalWanted);
    }
    const startIndex = index - totalHalf + totalOffset;
    const endIndex = startIndex + totalWanted;
    return array.slice(startIndex, endIndex);
}
function getSpecificStepsIndexes(stepsIndexes, currentStepIndex) {
    const firstIndex = 0;
    const lastIndex = stepsIndexes.length - 1;
    const lastButTwoIndex = stepsIndexes.length - 3;
    const lastButOneIndex = stepsIndexes.length - 2;
    const isFirst = currentStepIndex === firstIndex;
    const isSecond = currentStepIndex === 1;
    const isLastButTwoIndex = currentStepIndex === lastButTwoIndex;
    const isLastButOneIndex = currentStepIndex === lastButOneIndex;
    const isLast = currentStepIndex === lastIndex;
    if (isFirst || isSecond) {
        const closestValues = getClosestValuesFromIndex(stepsIndexes, currentStepIndex, 5);
        return [...closestValues, lastIndex];
    }
    if (isLastButTwoIndex || isLastButOneIndex || isLast) {
        const closestValues = getClosestValuesFromIndex(stepsIndexes, currentStepIndex, 5);
        return [firstIndex, ...closestValues];
    }
    const closestValues = getClosestValuesFromIndex(stepsIndexes, currentStepIndex, 4);
    return [firstIndex, ...closestValues, lastIndex];
}
function InnerHorizontalHeaderStep(props) {
    const { properties, element } = props.step;
    const { title } = element.props;
    const { done, enabled, identifier, last, readOnly: stepReadOnly } = getStepProperties(props.readOnly, props.mode, props.stepsMetadataProps, properties);
    const first = props.index === 0;
    const isCurrentStep = props.currentStepIdentifier === identifier;
    const isFirstSmall = first && (props.currentStepIndex - props.index > 2);
    const isLastSmall = last && (props.index - props.currentStepIndex > 2);
    const isSmall = props.showSpecificSteps && !isCurrentStep && (isFirstSmall || isLastSmall);
    const readOnly = Boolean(stepReadOnly);
    return (React.createElement(WizardHorizontalHeaderStep, { currentStep: isCurrentStep, displayIndex: props.index + 1, done: done, enabled: enabled, first: first, identifier: identifier, last: last, readOnly: readOnly, small: isSmall, title: title }));
}
function renderHorizontalHeaderSteps(props) {
    const stepsIndexes = props.stepsMetadata.map((_step, index) => index);
    const lastButOneIndex = props.stepsMetadata.length - 2;
    const showSpecificSteps = props.stepsMetadata.length > WIZARD_HORIZONTAL_HEADER_MAX_SHOWING_STEPS;
    const currentStepIndex = props.stepsMetadata.findIndex(({ properties }) => properties.identifier === props.currentStepIdentifier);
    const specificStepsIndexes = getSpecificStepsIndexes(stepsIndexes, currentStepIndex);
    const lastButOneSpecificStepIndex = specificStepsIndexes.length - 2;
    return (React.createElement("div", { className: "c-wizard-horizontal-header__steps t-color-signal-green" }, props.stepsMetadata.map((step, index) => {
        const isFirst = index === 0;
        const isLastButOneSpecificStep = index === lastButOneSpecificStepIndex;
        const isSpecificStep = specificStepsIndexes.includes(index);
        const showSeparator = index <= lastButOneIndex;
        const isFirstDashed = isFirst && (currentStepIndex - index > 2);
        const isLastButOneDashed = isLastButOneSpecificStep && (index - currentStepIndex >= 2);
        const isDashed = showSpecificSteps && (isFirstDashed || isLastButOneDashed);
        const isFaded = index >= currentStepIndex;
        const separatorClassName = classNames({
            'c-wizard-horizontal-header__separator': true,
            'c-wizard-horizontal-header__separator--dashed': isDashed,
            'c-wizard-horizontal-header__separator--faded': isFaded,
        });
        if (showSpecificSteps && !isSpecificStep) {
            return null;
        }
        return (React.createElement(Fragment, { key: step.properties.identifier },
            React.createElement(InnerHorizontalHeaderStep, { currentStepIdentifier: props.currentStepIdentifier, currentStepIndex: currentStepIndex, index: index, mode: props.mode, readOnly: false, showSpecificSteps: showSpecificSteps, step: step, stepsMetadataProps: props.stepsMetadataProps }),
            showSeparator
                ? React.createElement("div", { className: separatorClassName })
                : null));
    })));
}
function WizardHorizontalHeader(props) {
    if (props.mode !== WizardMode.HORIZONTAL) {
        return null;
    }
    return (React.createElement("div", { className: "c-wizard-horizontal-header", role: "status" }, renderHorizontalHeaderSteps(props)));
}
export { WizardHorizontalHeader, WIZARD_HORIZONTAL_HEADER_MAX_SHOWING_STEPS, };
//# sourceMappingURL=wizard-horizontal-header.js.map